import { createAnalyticsGroup } from 'js/lib/analytics'

const ediLogo = document.querySelectorAll('.js-c-logo--pedigree')

if (ediLogo.length > 0) {
  const track = createAnalyticsGroup('partner-logo--pedigree')
  const currentPage = window.location.href
  
  ediLogo.forEach(link => {
    
    if (link) {
      link.addEventListener('click', () => {
        track('click', `Pedigree logo from ${currentPage}`)
      })
    }
  })
}
